var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-tour',{attrs:{"name":"vueTour","steps":_vm.steps,"options":_vm.options,"callbacks":_vm.callbacks}}),_c('v-btn',{on:{"click":_vm.startTour}},[_vm._v(_vm._s(_vm.$t('tour.start')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }